"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@dnd-kit/core");

var _modifiers = require("@dnd-kit/modifiers");

var _sortable = require("@dnd-kit/sortable");

var _SortingcolumnGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/SortingcolumnGreyOutline"));

var _popover = _interopRequireDefault(require("../../popover"));

var _context3 = require("../context");

var _actions = require("../actions");

var _utils = require("../utils");

var _SortableGroup = _interopRequireDefault(require("./SortableGroup"));

var _SortableColumn = _interopRequireDefault(require("./SortableColumn"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable jsx-a11y/anchor-is-valid */
var PopoverBody = function PopoverBody(_ref) {
  var height = _ref.height;

  var _useTable = (0, _context3.useTable)(),
      columns = _useTable.columns,
      fireAction = _useTable.fireAction;

  var items = (0, _utils.rebuildColumnsDef)(columns);
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.MouseSensor, {
    activationConstraint: {
      distance: 10
    }
  }));
  /* istanbul ignore next */
  // We cannot test this function in an environment like jsdom where layouts are not rendered
  // Will test in other e2e testing framework in future like cypress for Orion.

  var onDragEnd = (0, _react.useCallback)(function (parent) {
    return function (event) {
      var active = event.active,
          over = event.over;

      if (over && active.id !== over.id) {
        var shuffled = [];

        if (parent) {
          shuffled = (0, _map["default"])(items).call(items, function (item) {
            if (item.key === parent) {
              item.children = (0, _utils.shuffleDndItems)(item.children, active, over);
            }

            return item;
          });
        } else {
          shuffled = (0, _utils.shuffleDndItems)(items, active, over);
        }

        var flattened = (0, _utils.extractColumns)(shuffled);
        fireAction((0, _actions.reorderColumns)(flattened));
      }
    };
  }, [fireAction, items]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-data-table-settings-panel",
    style: {
      height: "".concat(height, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Add and remove the columns to customize."), /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
    sensors: sensors,
    onDragEnd: onDragEnd(),
    modifiers: [_modifiers.restrictToFirstScrollableAncestor]
  }, /*#__PURE__*/_react["default"].createElement(_sortable.SortableContext, {
    items: (0, _map["default"])(items).call(items, function (i) {
      return i.key;
    })
  }, (0, _map["default"])(items).call(items, function (item) {
    if (item.children && item.key !== "__action__") {
      var _context, _context2;

      return /*#__PURE__*/_react["default"].createElement(_SortableGroup["default"], {
        id: item.key,
        data: item,
        key: item.key
      }, /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
        sensors: sensors,
        onDragEnd: onDragEnd(item.key),
        modifiers: [_modifiers.restrictToFirstScrollableAncestor]
      }, /*#__PURE__*/_react["default"].createElement(_sortable.SortableContext, {
        items: (0, _map["default"])(_context = item.children).call(_context, function (c) {
          return c.key;
        })
      }, (0, _map["default"])(_context2 = item.children).call(_context2, function (child) {
        return /*#__PURE__*/_react["default"].createElement(_SortableColumn["default"], {
          id: child.key,
          key: child.key,
          data: child
        });
      }))));
    }

    return item.key !== "__action__" && /*#__PURE__*/_react["default"].createElement(_SortableColumn["default"], {
      id: item.key,
      key: item.key,
      data: item
    });
  }))));
};

PopoverBody.propTypes = {
  height: _propTypes["default"].number
};

var Settings = function Settings(_ref2) {
  var height = _ref2.height,
      className = _ref2.className;
  return /*#__PURE__*/_react["default"].createElement(_popover["default"], {
    size: "sm",
    placement: "bottom",
    type: "uncontrolled",
    title: "Edit Columns",
    body: function body() {
      return /*#__PURE__*/_react["default"].createElement(PopoverBody, {
        height: height
      });
    },
    isOpen: true
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    "aria-label": "Settings Panel Icon",
    className: (0, _classnames["default"])("orion-data-grid__navigation--empty-button", className)
  }, /*#__PURE__*/_react["default"].createElement(_SortingcolumnGreyOutline["default"], {
    size: "sm",
    clickable: true
  })));
};

Settings.propTypes = {
  height: _propTypes["default"].number,
  className: _propTypes["default"].string
};
Settings.defaultProps = {
  height: 400
};
var _default = Settings;
exports["default"] = _default;